import { Injectable } from '@angular/core';
import { NgbDateAdapter, NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from './auth.service';
import moment from 'moment';
import { TranslateService } from './translate.service';

@Injectable({
  providedIn: 'root',
})
export class CustomAdapter extends NgbDateAdapter<string> {
  readonly DELIMITER = '-';

  fromModel(value: string | null): NgbDateStruct | null {
    if (value) {
      const date = value.split(this.DELIMITER);
      return {
        day: parseInt(date[0], 10),
        month: parseInt(date[1], 10),
        year: parseInt(date[2], 10),
      };
    }
    return null;
  }

  toModel(date: NgbDateStruct | null): string | null {
    return date ? date.year + this.DELIMITER + date.month + this.DELIMITER + date.day : null;
  }
}

@Injectable({
  providedIn: 'root',
})
export class CustomDateParserFormatter extends NgbDateParserFormatter {
  constructor(
    private readonly authService: AuthService,
    private readonly translateService: TranslateService
  ) {
    super();
    const dateFormat = this.authService.getUserSettings('dateFormat');
    this.userDateFormat = (typeof dateFormat === 'string' ? dateFormat : null) || 'YYYY-MM-DD';
    this.lang = this.translateService.getLang().toString();
  }

  readonly DELIMITER = '-';
  private readonly lang: string;
  private userDateFormat: string;

  parse(value: string): NgbDateStruct | null {
    const dateFormat = this.authService.getUserSettings('dateFormat');
    this.userDateFormat = (typeof dateFormat === 'string' ? dateFormat : null) || 'YYYY-MM-DD';
    const newMoment = moment(value, this.userDateFormat, this.lang);
    if (newMoment.isValid()) {
      const result = {
        day: newMoment.date(),
        month: newMoment.month() + 1,
        year: newMoment.year(),
      };
      return result;
    }
    return null;
  }

  format(date: NgbDateStruct | null): string {
    const ngbObj = JSON.parse(JSON.stringify(date));
    const newMoment = moment();
    if (ngbObj) {
      ngbObj.month--;
      newMoment.month(ngbObj.month);
      newMoment.date(ngbObj.day);
      newMoment.year(ngbObj.year);
      if (newMoment.isValid()) {
        const result = newMoment.locale(this.lang).format(this.userDateFormat);
        return result;
      }
    }
    return '';
  }

  validateDate(dateString: string): boolean {
    const formats = [
      { format: 'MM/dd/yyyy', regex: /^\d{2}\/\d{2}\/\d{4}$/ },
      { format: 'dd/MM/yyyy', regex: /^\d{2}\/\d{2}\/\d{4}$/ },
      { format: 'yyyy-MM-dd', regex: /^\d{4}-\d{2}-\d{2}$/ },
      { format: 'yyyy-dd-MM', regex: /^\d{4}-\d{2}-\d{2}$/ },
      { format: 'yyyy/dd/MM', regex: /^\d{4}\/\d{2}\/\d{2}$/ },
      { format: 'yyyy/MM/dd', regex: /^\d{4}\/\d{2}\/\d{2}$/ },
      {
        format: 'MMMM do, yyyy',
        regex:
          /^(January|February|March|April|May|June|July|August|September|October|November|December)\s\d{1,2}(st|nd|rd|th),\s\d{4}$/,
      },
    ];

    return formats.some(({ regex }) => regex.test(dateString));
  }
}

@Injectable({
  providedIn: 'root',
})
export class DDMMYYYYParserFormatter extends NgbDateParserFormatter {
  readonly DELIMITER = '.';

  parse(value: string): NgbDateStruct | null {
    if (value) {
      const dateParts = value.trim().split(this.DELIMITER);
      if (dateParts.length === 3) {
        return {
          day: parseInt(dateParts[0], 10),
          month: parseInt(dateParts[1], 10),
          year: parseInt(dateParts[2], 10),
        };
      }
    }
    return null;
  }

  format(date: NgbDateStruct | null): string {
    if (!date) {
      return '';
    }
    const day = date.day < 10 ? `0${date.day}` : date.day;
    const month = date.month < 10 ? `0${date.month}` : date.month;
    return `${day}${this.DELIMITER}${month}${this.DELIMITER}${date.year}`;
  }
}
